export default __webpack_public_path__ + "static/media/return.4e5f9f79.svg";